import { render, staticRenderFns } from "./level-actions.vue?vue&type=template&id=0b82b992"
import script from "./level-actions.vue?vue&type=script&lang=js"
export * from "./level-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports